// menu adjustments
document.addEventListener('DOMContentLoaded', () => {
  // Only run ≥ 991px
  if (!window.matchMedia('(min-width: 991px)').matches) return;

  const headerInner = document.querySelector('.header__inner');
  const originalNav = document.querySelector('.header__nav');
  const logo = document.querySelector('.header__logo');

  if (!headerInner || !originalNav || !logo) return;

  // Prevent running twice
  if (document.querySelector('.header__nav.menu-right')) return;

  const ul = originalNav.querySelector('ul');
  if (!ul) return;

  const items = Array.from(ul.children);
  if (!items.length) return;

  const splitIndex = Math.ceil(items.length / 2);

  // mark original
  originalNav.classList.add('menu-left');

  // clone for right
  const rightNav = originalNav.cloneNode(true);
  rightNav.classList.remove('menu-left');
  rightNav.classList.add('menu-right');

  const rightUl = rightNav.querySelector('ul');

  // split
  items.slice(splitIndex).forEach(el => el.remove());

  const rightItems = Array.from(rightUl.children);
  rightItems.slice(0, splitIndex).forEach(el => el.remove());

  // insert after logo
  headerInner.insertBefore(rightNav, logo.nextSibling);
});